// extracted by mini-css-extract-plugin
export default {"base":"MSAHeatMapNew_base__QMAlb","map_container":"MSAHeatMapNew_map_container__GqliS"};